<template>
  <div class="form-group">
    <label v-if="currentId === null" class="control-label col-md-3">{{ title }}</label>
    <label
        v-else-if="currentId !== null"
        class="control-label col-md-3"
    >
      <a :href="generateRoute()" target="_blank">{{ title }} <i class="fa fa-link"></i></a>
    </label>
    <div class="col-md-9 user-input">
      <div class="col-md-6">
        <input v-model="email" placeholder="Wprowadź adres email " class="form-control" type="text" :disabled="inputDisabled">
      </div>
      <div class="col-md-4">
          <select v-model="brandId" :disabled="inputDisabled" title="Marka" class="form-control">
              <option :value="null">Wszystkie</option>
              <option v-for="brand in brands" :key="brand.id" :value="brand.id">
                  {{ brand.name }}
              </option>
          </select>
      </div>
      <div class="col-md-2">
        <div class="btn btn-primary btn-block fa fa-search" :disabled="btnDisabled" :title="btnTitle" @click="getUserData">
            &nbsp;
        </div>
      </div>
      <span class="help-block" style="padding-left: 15px; color: #a94442">
        <p v-for="(error, index) in errorsToDisplay" :key="index">{{error}}</p>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserFinder',
  props: {
    title: {
      type: String,
      default: ''
    },
    btnTitle: {
      type: String,
      default: 'Pobierz dane użytkownika'
    },
    btnDisabled: {
      type: Boolean,
      default: false
    },
    inputDisabled: {
      type: Boolean,
      default: false
    },
    currentId: {
      type: Number,
      default: null
    },
    context: {
      type: String,
      required: true
    },
    errors: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    },
    initialInput: {
      type: String,
      required: false,
      default: null
    },
    initialBrand: {
      type: [String, Number],
      required: false,
      default: null
    },
    name: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      searchHistory: [],
      email: null,
      brandId: null,
      brands: [],
    }
  },
  computed: {
    errorsToDisplay: function () {
      if (this.name === null || typeof this.errors[this.name] === 'undefined') {
        return []
      }
      let errors = []
      for (let key in this.errors) {
        if (key === this.name) {
          for (let err in this.errors[key]) {
            errors.push(this.errors[key][err])
          }
        }
      }
      return errors
    }
  },
  watch: {
    initialInput(value) {
      this.email = value
    },
    initialBrand(value) {
      this.brandId = value
    }
  },
  mounted() {
    this.getBrands()
  },
  methods: {
    getUserData() {
      if (this.btnDisabled) {
        return
      }
      const url = Routing.generate('api_get_client_by_email', {
        context: 'edit',
        email: this.email,
        brandId: this.brandId,
      })
      this.$http.get(url).then(res => {
        this.$emit('user-found', res.data)

        if (typeof res.data === 'string' || res.data === null) {
          const history = this.searchHistory[this.searchHistory.length - 1]
          if (history) {
            this.email = history.email
            this.brandId = history.brandId
          }
        } else {
          this.searchHistory.push(
            {
              email: res.data.email,
              brandId: res.data.brand
            }
          )
          this.email = res.data.email
          this.brandId = res.data.brand
        }
      })
    },
    generateRoute() {
      return Routing.generate('client_show', { id: this.currentId })
    },
    getBrands() {
      this.$http.get(Routing.generate('api_get_brands', { context: 'dropdown' })).then(response => {
        this.brands = response.data
      }, response => {
        this.handleAjaxError(response)
      })
    },
  }
}
</script>

<style scoped>
.user-input {
    padding-left: 0;
    passing-right: 0;
}

.user-input .col-md-6 {
    padding-right: 0;
}

.user-input .col-md-4 {
    padding-right: 5px;
    padding-left: 5px;
}

.user-input .col-md-2 {
    padding-right: 0;
    padding-left: 0;
}
</style>
